var _path, _mask, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 3.5a.5.5 0 00-.5-.5H14c-2.762 0-5 2.015-5 4.5v2.7H6.5a.5.5 0 00-.5.5v2.6a.5.5 0 00.5.5H9v6.7a.5.5 0 00.5.5h3a.5.5 0 00.5-.5v-6.7h2.619c.225 0 .422-.15.483-.366l.721-2.6a.5.5 0 00-.481-.634H13V7.5c0-.497.447-.9 1-.9h2.5a.5.5 0 00.5-.5V3.5z",
    fill: "#231F20"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "facebook_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 3,
    width: 11,
    height: 18
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 3.5a.5.5 0 00-.5-.5H14c-2.762 0-5 2.015-5 4.5v2.7H6.5a.5.5 0 00-.5.5v2.6a.5.5 0 00.5.5H9v6.7a.5.5 0 00.5.5h3a.5.5 0 00.5-.5v-6.7h2.619c.225 0 .422-.15.483-.366l.721-2.6a.5.5 0 00-.481-.634H13V7.5c0-.497.447-.9 1-.9h2.5a.5.5 0 00.5-.5V3.5z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#facebook_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A3F6E",
    d: "M0 0h24v24H0z"
  }))));
}

export default SvgFacebook;